var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c(
      "td",
      { staticClass: "clickable", on: { click: _vm.toggleBidDetails } },
      [
        _c("i", {
          staticClass: "fa fa-angle-down f-s-15 m-r-5",
          class: { "fa-rotate-180": _vm.showBidDetails },
          attrs: { "aria-hidden": "true" }
        })
      ]
    ),
    _vm._v(" "),
    _c("td", { class: _vm.bidStatus.class }, [
      _vm._v(_vm._s(_vm.bidStatus.name))
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.bidDateTime))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.$t(_vm.bidRecord.winningBid ? "YES" : "NO")))]),
    _vm._v(" "),
    _c("td", [
      _c(
        "a",
        {
          staticClass: "text-underline",
          attrs: {
            href: `/#/dashboard/campaign/${_vm.bidRecord.campaignId}`,
            target: "_blank"
          }
        },
        [_vm._v("\n      " + _vm._s(_vm.bidRecord.campaignName) + "\n    ")]
      ),
      _vm._v(" "),
      _c("i", {
        staticClass: "fa fa-external-link m-l-5",
        attrs: { "aria-hidden": "true" }
      })
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.bidRecord.publisherName))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.bidAmount))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }